import moment from 'moment';

/**
 * 计算目标日期在指定时间单位下对应的时间范围
 */
export const calculateDateRange = (date, unit = 'day') => {
	return [moment(date).startOf(unit).valueOf(), moment(date).endOf(unit).valueOf()];
};

/**
 * @description: 0 默认 1 创建 2 投关日历
 */
export const SCHEDULE_TYPE = {
	DEFAULT: 0, // 默认
	CREATE: 1, // 创建
	CUSTOMS_CALENDAR: 2 // 投关日历
};
/**
 * @description: 0 沟通 1 投关活动 2 公告 3 新闻 4 业绩披露 5 股东大会
 */
export const SCHEDULE_CUSTOMS_TYPE = {
	COMMUNICATION: 0, // 沟通
	IRSTORE: 1, // 投关活动
	ANNOUNCEMENT: 2, // 公告
	NEWS: 3, // 新闻
	PERFORMANCE_DISCLOSURE: 4, // 业绩披露
	SHAREHOLDERS_MEETING: 5, // 股东大会
	DIVIDENDS: 6 //分红送配
};
export const fromIrstoreType = Object.entries(SCHEDULE_CUSTOMS_TYPE)
	.filter(([key]) => key !== 'COMMUNICATION')
	.map(item => item[1]);
export const isIRActivityType = customsType => fromIrstoreType.includes(customsType);
export const checkScheduleHourHide = data => {
	let hideHour = false;
	if (data.customsType === SCHEDULE_CUSTOMS_TYPE.IRSTORE) {
		if (data?.investmentActivityVO?.sourceType === 1) {
			// 自主添加
			hideHour = true;
		}
		if (data?.investmentActivityType === 3) {
			hideHour = true;
		}
	}
	if (isIRActivityType(data.customsType)) {
		hideHour = true;
	}
	return hideHour;
};

export const nonCalendarPermission = vo => {
	const { innerPermission, outPermission } = vo;
	return outPermission === 2 || innerPermission === 2;
};
export const getScheduleThemeName = data => {
	if (!data) return '-';
	const { calendarVO = {}, scheduleTheme } = data;
	return nonCalendarPermission(calendarVO) ? '忙碌' : scheduleTheme || '-';
};

/**
 * 根据指定的时间范围过滤数据
 * @param {Array} timeRange - 时间范围，格式为 [开始时间, 结束时间]
 * @param {Array} data - 待过滤的数据数组
 * @param {Boolean} isHour - 是否按照小时级别过滤
 * @returns {Array|Boolean} - 返回符合条件的数据数组，如果没有符合条件的数据则返回false
 */
export const filterDataByTimeRange = (timeRange, data, isHour = false) => {
	// 用于存储符合条件的数据项
	const resultMap = new Map();
	// 过滤出满足指定日期范围内的数据
	(data || []).forEach(d => {
		// TODO format propName option: stime/etime/color...
		const { scheduleStartTime, scheduleEndTime } = d;

		// 判断当前元素的时间范围是否与目标range有重叠（日期级别）
		const isDateRangeOverlap = scheduleStartTime <= timeRange[1] && scheduleEndTime >= timeRange[0];

		let isTimeRangeOverlap = isDateRangeOverlap;
		// 如果存在时刻维度 并且之前判断的时间范围有重叠，进一步检查当前数据的开始时间的时分 是否落在目标范围的时分内
		if (isHour && isTimeRangeOverlap) {
			const startTimeHour = moment(scheduleStartTime).format('HH:mm');
			const rangeStartHour = moment(timeRange[0]).format('HH:mm');
			const rangeEndHour = moment(timeRange[1]).format('HH:mm');
			isTimeRangeOverlap = startTimeHour >= rangeStartHour && startTimeHour <= rangeEndHour;
		}

		if (isTimeRangeOverlap) {
			if (resultMap.get(timeRange)) {
				// 追加到已有数组中，并更新rangeMap
				resultMap.set(timeRange, [...resultMap.get(timeRange), d]);
			} else {
				resultMap.set(timeRange, [d]);
			}
		}
	});
	if (resultMap.get(timeRange)) {
		return resultMap.get(timeRange);
	}
	return false;
};

/**
 * 获取指定日期所在月份的日期范围
 * @param {Date} date - 指定日期
 * @returns {Array} - 返回日期范围，格式为 [开始日期, 结束日期]
 */
export const getMonthRange = date => {
	// 日程请求区间 当前月份加上前后月
	const rangeStart = moment(date).subtract(1, 'months').startOf('month').valueOf();
	const rangeEnd = moment(date).add(1, 'months').endOf('month').valueOf();
	const range = [rangeStart, rangeEnd];
	return range;
};

// ------- 主题颜色控制

export const defaultColor = '#3964E5';
export const calendarColorMap = [
	'#3964E5',
	'#73DCFF',
	'#9673FF',
	'#FF7373',
	'#FF9673',
	'#FFB973',
	'#FFDC73',
	'#E5E567',
	'#C6E567',
	'#67E587'
];
export const calendarFade01ColorMap = {
	'#3964E5': {
		fade01Color: 'rgba(57, 100, 229, 0.1)',
		fadeImage: 'https://comein-image.oss-cn-hangzhou.aliyuncs.com/web/irm/web/calendar/fade_1.png'
	},
	'#73DCFF': {
		fade01Color: 'rgba(115, 220, 255, 0.1)',
		fadeImage: 'https://comein-image.oss-cn-hangzhou.aliyuncs.com/web/irm/web/calendar/fade_2.png'
	},
	'#9673FF': {
		fade01Color: 'rgba(150, 115, 255, 0.1)',
		fadeImage: 'https://comein-image.oss-cn-hangzhou.aliyuncs.com/web/irm/web/calendar/fade_3.png'
	},
	'#FF7373': {
		fade01Color: 'rgba(255, 115, 115, 0.1)',
		fadeImage: 'https://comein-image.oss-cn-hangzhou.aliyuncs.com/web/irm/web/calendar/fade_4.png'
	},
	'#FF9673': {
		fade01Color: 'rgba(255, 150, 115, 0.1)',
		fadeImage: 'https://comein-image.oss-cn-hangzhou.aliyuncs.com/web/irm/web/calendar/fade_5.png'
	},
	'#FFB973': {
		fade01Color: 'rgba(255, 185, 115, 0.1)',
		fadeImage: 'https://comein-image.oss-cn-hangzhou.aliyuncs.com/web/irm/web/calendar/fade_6.png'
	},
	'#FFDC73': {
		fade01Color: 'rgba(255, 220, 115, 0.1)',
		fadeImage: 'https://comein-image.oss-cn-hangzhou.aliyuncs.com/web/irm/web/calendar/fade_7.png'
	},
	'#E5E567': {
		fade01Color: 'rgba(229, 229, 103, 0.1)',
		fadeImage: 'https://comein-image.oss-cn-hangzhou.aliyuncs.com/web/irm/web/calendar/fade_8.png'
	},
	'#C6E567': {
		fade01Color: 'rgba(198, 229, 103, 0.1)',
		fadeImage: 'https://comein-image.oss-cn-hangzhou.aliyuncs.com/web/irm/web/calendar/fade_9.png'
	},
	'#67E587': {
		fade01Color: 'rgba(103, 229, 135, 0.1)',
		fadeImage: 'https://comein-image.oss-cn-hangzhou.aliyuncs.com/web/irm/web/calendar/fade_10.png'
	}
};
// 日历颜色
export const insetCalendarColorVar = color => {
	const safeColorVal = color && calendarColorMap.includes(color) ? color : defaultColor;
	const safeFade01ColorVal = calendarFade01ColorMap[safeColorVal].fade01Color;
	return {
		'--calendar-color': safeColorVal,
		'--calendar-fade-1-color': safeFade01ColorVal
	};
};

const storeCalendar = {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {}
};

export default storeCalendar;
